import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  bottomPart: {
    height: "20vh",
    width: "100%",
    backgroundColor: "#f2f2f3",
    position: "static",
  },
  leftPart: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    height: "75vh",
    flexDirection: "column",
    color: "#fff",
  },
  rightPart: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "75vh",
  },
  capital: {
    fontSize: 20,
    fontWeight: "bold",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  title: {
    fontSize: 42,
    fontWeight: "bolder",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  content: {
    fontSize: 16,
    color: theme.palette.text.secondary,
    width: 450,
  },
  bottomContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "20vh",
    color: "#000",
    fontWeight: "bolder",
  }
}));